const map = {
  skipFont: ({ theme }) => theme.fonts.set(`primary`, `bold`),
  skipForeground: ({ theme }) => theme.colors.offWhite,
  skipBackground: ({ theme }) => theme.colors.darkGrey,
}

export default map
